import { useEffect, useState } from 'react';

import big from "./assets/Big.webp";

const words = ["logistics", "Freight management"];

const HeroSection = () => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % words.length);
    }, 2000);
    return () => clearInterval(timer);
  }, []);
  

  return (
    <section className="bg-[#E0FFE9] font-poppins w-full">
      <div className="max-w-7xl mx-auto flex flex-col-reverse md:flex-row items-center gap-10 px-6 py-16">
        {/* Text Section */}
        <div className="w-full md:w-6/12 text-center md:text-left">
          <p className="text-xs sm:text-sm font-medium text-gray-900 mb-4">
            SUPPLY CHAIN & LOGISTICS
          </p>

          <h1 className="mb-6 text-3xl sm:text-4xl md:text-5xl font-extrabold text-gray-900 leading-tight">
            Redefining the future
            <br />
            of{" "}
            <span className="inline-block h-[70px] overflow-hidden relative align-middle">
              <div
                className="transition-transform duration-[600ms] ease-in-out"
                style={{ transform: `translateY(-${index * 70}px)` }}
              >
                {words.map((word, i) => (
                  <div
                    key={i}
                    className="h-[70px] flex items-center text-[#07862B] text-[32px] sm:text-[42px] md:text-[48px] font-bold"
                  >
                    {word}
                  </div>
                ))}
              </div>
            </span>
          </h1>

          <p className="text-gray-700 text-sm sm:text-base md:text-lg leading-relaxed max-w-xl mx-auto md:mx-0">
            Third-party integration uses external services and APIs to
            streamline supply chains. In today’s fast-changing logistics
            industry, digital transformation is essential.
          </p>
        </div>

        {/* Image Section */}
        <div className="w-full md:w-6/12 flex justify-center">
          <img
            src={big}
            alt="Global logistics illustration"
            className="w-[90%] max-w-[400px] sm:max-w-[500px] md:max-w-[560px]"
          />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
